import React from "react";
import { connect } from "react-redux";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import Breadcrumbs from "components/frontend/listings/_shared/breadcrumbs";

import ImagePlaceholder from "images/listings/placeholder.png";
import routes from "routes";
import ReactPlayer from "react-player";

import {
  openContactForm,
  openMessageModal,
  closeMessageModal,
} from "actions/modal/actions";

import { dateDiffInDays } from "utils/dates";

const pluralize = require("pluralize");

function Header(props) {
  const { listing } = props;

  const breadcrumbData = [
    {
      text: "For Sale",
      link: routes.forSale,
    },
  ];
  const aircraftType = listing.saleDetails.model.type;
  if (aircraftType)
    breadcrumbData.push({
      text: pluralize(aircraftType.title),
      link: `${routes.forSale}?types=${aircraftType.value}`,
    });

  const aircraftMake = listing.saleDetails.model.make;
  if (aircraftMake)
    breadcrumbData.push({
      text: aircraftMake.name,
      link: `${routes.forSale}?make=${aircraftMake.slug}`,
    });

  const aircraftModel = listing.saleDetails.model;
  if (aircraftModel)
    breadcrumbData.push({
      text: aircraftModel.name,
    });

  const imageCss = () => {
    if (listing.images && listing.images.length > 0) {
      const first = listing.images.slice(0, 1).shift();
      return {
        backgroundImage: `url('${first.url}')`,
        backgroundColor: "transparent",
      };
    } else if (listing.thumbnail) {
      return {
        backgroundImage: `url('${listing.thumbnail}')`,
        backgroundColor: "transparent",
      };
    } else {
      return {};
    }
  };

  const listingTitle = () => {
    return <h1 className="title">{listing.title}</h1>;
  };

  const saleTypes = () => {
    const { price, salePrice, saleFor } = listing.saleDetails;
    const { status } = listing;

    if (status.value === "sold")
      return (
        <div className="sale-types">
          <div className="sale-type-price">
            <span className="label">Price:</span>
            <span className="value">SOLD</span>
          </div>
        </div>
      );

    let salePriceDisplay;
    if (salePrice) {
      switch (salePrice.value) {
        case "price":
          if (price) {
            salePriceDisplay = new Intl.NumberFormat("en-us", {
              style: "currency",
              currency: "USD",
            }).format(price);
          } else {
            salePriceDisplay = "Unknown";
          }

          break;
        default:
          salePriceDisplay = salePrice.title;
          break;
      }
    } else if (price) {
      salePriceDisplay = new Intl.NumberFormat("en-us", {
        style: "currency",
        currency: "USD",
      }).format(price);
    }

    const saleForDisplay = saleFor.map((sale, i) => {
      return (
        <li key={i} className="for-type value">
          <span className="value">{sale.title}</span>
          <span className="separator">&#8226;</span>
        </li>
      );
    });

    return (
      <div className="sale-types">
        {salePriceDisplay && (
          <div className="sale-type-price">
            <span className="label">Price:</span>
            <span className="value">{salePriceDisplay}</span>
          </div>
        )}

        {saleForDisplay && (
          <div className="sale-type-for">
            <span className="label">For:</span>
            <ul className="values">{saleForDisplay}</ul>
          </div>
        )}
      </div>
    );
  };

  const highlights = () => {
    // Price <span>Deal Pending</span>
    const highlightsArray = listing.highlights;
    if (highlightsArray) {
      return highlightsArray.map((type) => type.name);
    }
    return [];
  };

  const headerImage = () => {
    const showRibbon = ["sold", "removed", "draft", "pending"].includes(
      listing.status.value
    );
    let showSubtext = ["removed", "draft", "pending"].includes(
      listing.status.value
    );
    if (
      listing.status.value === "sold" &&
      dateDiffInDays(listing.unPublishedAt, new Date()) > 30
    ) {
      showSubtext = true;
    }
    return (
      <div
        id="listing-image"
        className="listing-image image"
        style={imageCss()}
      >
        {showRibbon && (
          <div className={`corner-ribbon top-left ${listing.status.value}`}>
            <div className="headline">{listing.status.title}</div>
            {showSubtext && (
              <div className="subtext">Only You Can See This Page</div>
            )}
          </div>
        )}
        <img src={ImagePlaceholder} alt="" className="img-fluid" />
      </div>
    );
  };

  const openVideoModal = () => {
    if (props.openMessageModal) {
      props.openMessageModal(
        <div className="video-player-wrapper">
          <ReactPlayer url={listing.video} width="100%" height="auto" />
        </div>,
        null,
        "video-modal",
        true
      );
    }
  };

  return (
    <header className="for-sale-detail-header detail-header">
      <Container>
        <Row>
          <Col>
            <Breadcrumbs data={breadcrumbData} />
            {listingTitle()}
          </Col>
        </Row>
        <Row>
          <Col sm={12} md={4} className="listing-data pt-4">
            <div id="listing-image-mobile" className="d-md-none row">
              {headerImage()}
            </div>
            <div className="sub-title">{saleTypes()}</div>
            {(listing.level.value !== "basic" || true) && (
              <ul className="highlights-list">
                {highlights().map((item, i) => (
                  <li key={i} className="highlight">
                    {item}
                  </li>
                ))}
              </ul>
            )}
            <Row className="action-buttons my-5 d-flex justify-content-center justify-content-md-start">
              <Col xs={8} sm={6} md={12} lg={8} xl={7}>
                <div>
                  <button
                    className="btn btn-primary btn-wide mb-3 contact-button"
                    onClick={() => props.openContactForm(listing)}
                  >
                    Contact
                  </button>
                </div>
                {listing.document && (
                  <div>
                    <a
                      href={listing.document}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary btn-wide mb-3 download-button"
                    >
                      Download Specs
                    </a>
                  </div>
                )}

                {listing.video && (
                  <div>
                    <button
                      className="btn btn-primary btn-wide mb-3 contact-button"
                      onClick={openVideoModal}
                    >
                      View Video
                    </button>
                  </div>
                )}

                {listing.video360 && (
                  <div>
                    <a
                      href={listing.video360}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-primary btn-wide mb-3 download-button"
                    >
                      360&deg; Video
                    </a>
                  </div>
                )}
              </Col>
            </Row>
          </Col>
          <Col
            md={8}
            id="listing-image-desktop"
            className="right d-none d-md-flex p-0"
          >
            {headerImage()}
          </Col>
        </Row>
      </Container>
    </header>
  );
}

const keyDispatchToProps = (dispatch) => {
  return {
    openContactForm: (listing) => dispatch(openContactForm(listing)),
    openMessageModal: (message, actions, css, showClose) =>
      dispatch(openMessageModal({ message, actions, css, showClose })),
    closeMessageModal: () => dispatch(closeMessageModal()),
  };
};

export default connect(null, keyDispatchToProps)(Header);
